// const imgeurl = "http://localhost:3001/uploads/image/";
const imgeurl = "https://api.puneri.foxberry.link/public/uploads/image/";

export default imgeurl;
